//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/mesh/messaging.proto.
 */
export const file_dxos_mesh_messaging = /*@__PURE__*/ fileDesc("ChlkeG9zL21lc2gvbWVzc2FnaW5nLnByb3RvEhNkeG9zLm1lc2gubWVzc2FnaW5nImIKD1JlbGlhYmxlUGF5bG9hZBIoCgptZXNzYWdlX2lkGAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIlCgdwYXlsb2FkGAIgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueSI7Cg9BY2tub3dsZWRnZW1lbnQSKAoKbWVzc2FnZV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXliBnByb3RvMw", [file_google_protobuf_any, file_dxos_keys]);
/**
 * Describes the message dxos.mesh.messaging.ReliablePayload.
 * Use `create(ReliablePayloadSchema)` to create a new message.
 */
export const ReliablePayloadSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_messaging, 0);
/**
 * Describes the message dxos.mesh.messaging.Acknowledgement.
 * Use `create(AcknowledgementSchema)` to create a new message.
 */
export const AcknowledgementSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_messaging, 1);
//# sourceMappingURL=messaging_pb.js.map